import { render, staticRenderFns } from "./videoDialog.vue?vue&type=template&id=4f920059&scoped=true"
import script from "./videoDialog.vue?vue&type=script&lang=js"
export * from "./videoDialog.vue?vue&type=script&lang=js"
import style0 from "./videoDialog.vue?vue&type=style&index=0&id=4f920059&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f920059",
  null
  
)

export default component.exports